(function() {
    const tests = document.querySelector('section.tests');
    const questionContainer = tests.querySelector('.tests__list');
    const nextButton = tests.querySelector('.tests__button');
    const resultTemplate = document.getElementById('result-template');

    // Находим изменяемые элементы вопроса
    const numberEl = questionContainer.querySelector('.tests__number');
    const questionTextEl = questionContainer.querySelector('.tests__question');
    const labelsContainer = questionContainer.querySelector('.tests__form');
    
    // Берем эталонный лейбл из HTML, чтобы клонировать его при необходимости
    const labelArchetype = questionContainer.querySelector('.tests__label').cloneNode(true);

    let currentQuestion = 0;
    let userPoints = 0;
    let currentPoint = 0;

    // СЮДА МОЖНО ДОБАВЛЯТЬ СКОЛЬКО УГОДНО ВОПРОСОВ И ВАРИАНТОВ ОТВЕТОВ
    const QUESTIONS_DATA = [
        {
            question: 'Есть ли у компании просроченные обязательства?',
            answers: [
                { text: 'Нет, обязательства исполняются в срок.', point: 0 },
                { text: 'Есть отдельные задержки или напряжение с платежами, но ситуация контролируема.', point: 1 },
                { text: 'Просрочка растет, есть претензии, иски, аресты или риск банкротства.', point: 6 }
            ]
        },
        {
            question: 'Определен ли сейчас контроль над ключевыми решениями, документами, счетами и подписями?',
            answers: [
                { text: 'Контроль и полномочия закреплены, решения принимаются без сбоев.', point: 0 },
                { text: 'Есть зависимость от одного-двух ключевых людей или отдельные спорные зоны, но управление сохраняется.', point: 1 },
                { text: 'Контроль не определен.', point: 6 }
            ]
        },
        {
            question: 'Есть ли конфликт между собственниками, кредиторами, руководством, наследниками или ключевыми контрагентами?',
            answers: [
                { text: 'Нет, ключевые участники действуют согласованно.', point: 0 },
                { text: 'Есть разногласия, но они пока не мешают операционной работе.', point: 1 },
                { text: 'Конфликт есть или уже перешел в спор.', point: 2 }
            ]
        },
        {
            question: 'Есть ли понятный сценарий сохранения или изменения структуры собственности?',
            answers: [
                { text: 'Да, структура устойчива, сценарий преемственности или выхода собственника оформлен.', point: 0 },
                { text: 'Общий сценарий есть, но не все договоренности юридически или управленчески закреплены.', point: 1 },
                { text: 'Понятного сценария нет.', point: 2 }
            ]
        },
        {
            question: 'Готовы ли вы рассмотреть привлечение инвестора для стабилизации бизнеса?',
            answers: [
                { text: 'Да, готовы, в том числе к частичной потере контроля, если это позволит сохранить бизнес.', point: 0 },
                { text: 'Да, но только при сохранении контроля и согласованной роли инвестора.', point: 1 },
                { text: 'Нет, не готовы.', point: 2 }
            ]
        }
    ];

    // НАСТРОЙКА БАЛЛОВ ДЛЯ РЕЗУЛЬТАТОВ (Можно легко менять диапазоны)
    const RESULTS_CONFIG = [
        {
            maxPoints: 2,
            title: 'Ситуация управляемая',
            intro: 'Бизнес сохраняет контроль над обязательствами, решениями и ключевыми участниками. Существенных признаков кризиса пока нет, но отдельные риски могут накапливаться незаметно.',
            todo: 'Проверить карту рисков, структуру полномочий, ключевые обязательства, сценарий преемственности или выхода собственника, а также план действий на случай ухудшения условий.'
        },
        {
            maxPoints: 5,
            title: 'Зона повышенного внимания',
            intro: 'У бизнеса уже есть отдельные признаки напряжения: финансовые, управленческие, корпоративные или переговорные. Ситуация может оставаться контролируемой, но без диагностики есть риск пропустить момент. Это пограничная зона: проблемы еще могут выглядеть рабочими, но уже способны сложиться в специальную ситуацию, если их не связать в общий сценарий.',
            todo: 'Провести диагностику: кто реально контролирует процесс, какие обязательства критичны, кто может заблокировать решение, какие конфликты уже влияют на бизнес и где находится предел допустимого риска.'
        },
        {
            maxPoints: 8,
            title: 'Специальная ситуация',
            intro: 'Ситуация уже требует не отдельного юридического, финансового или переговорного действия, а связанного сценария. Это и есть специальная ситуация: одновременно затронуты деньги, контроль, участники, сроки, переговорная позиция или стоимость бизнеса. Здесь важно собрать управляемую конструкцию решения.',
            todo: 'Диагностика, карта рисков, возможные варианты сделки или реструктуризации, контрольные точки и условия выхода из ситуации.'
        },
        {
            maxPoints: Infinity, // Все, что выше предыдущего максимума
            title: 'Критическая зона',
            intro: 'Риски уже могут влиять на управляемость бизнеса, стоимость актива, отношения с кредиторами, собственниками, руководством или партнерами. Это уже острая форма специальной ситуации: промедление может снижать стоимость бизнеса, усиливать конфликт и сокращать количество доступных сценариев.',
            todo: 'Быстро определить предел риска, возможные сценарии, условия сохранения контроля и варианты стабилизации бизнеса.'
        }
    ];

    const getResultData = () => {
        const found = RESULTS_CONFIG.find(config => userPoints <= config.maxPoints);
        // если поиск выдал undefined (например, из-за NaN), вернем последний элемент
        return found || RESULTS_CONFIG[RESULTS_CONFIG.length - 1];
    };

    const renderResult = () => {
        const resData = getResultData();
        
        // Клонируем структуру обновленного шаблона результатов
        const clone = resultTemplate.content.cloneNode(true);
        
        // Наполняем клон данными
        clone.querySelector('.tests_result__title').textContent = resData.title;
        clone.querySelector('.tests_result__text').textContent = resData.intro;
        clone.querySelector('.tests_result_window__text').textContent = resData.todo;

        // Переключаем класс главного контейнера, полностью очищаем его и вставляем результат
        questionContainer.classList.add('tests_result');
        questionContainer.innerHTML = '';
        questionContainer.appendChild(clone);

        nextButton.remove();
    };

    const updateQuestionDOM = () => {
        if (currentQuestion >= QUESTIONS_DATA.length) {
            renderResult();
            return;
        }

        const currentQuestionData = QUESTIONS_DATA[currentQuestion];

        numberEl.textContent = `${currentQuestion + 1}/${QUESTIONS_DATA.length}`;
        questionTextEl.textContent = currentQuestionData.question;

        labelsContainer.innerHTML = '';
        
        currentQuestionData.answers.forEach((answer) => {
            const labelClone = labelArchetype.cloneNode(true);
            const input = labelClone.querySelector('.tests__input');
            
            labelClone.querySelector('.tests__label_text').textContent = answer.text;
            input.value = answer.point;
            input.checked = false;

            input.addEventListener('change', e => {
                currentPoint = +e.target.value;
                nextButton.disabled = false;
            });

            labelsContainer.appendChild(labelClone);
        });

        nextButton.disabled = true;
        currentQuestion++;
    };

    const initTest = () => {
        // Слушаем изменения в первом вопросе
        questionContainer.querySelectorAll('.tests__input').forEach(el => {
            el.addEventListener('change', e => {
                currentPoint = +e.target.value;
                nextButton.disabled = false;
            });
        });

        nextButton.addEventListener('click', () => {
            userPoints += currentPoint;
            currentPoint = 0;
            updateQuestionDOM();
        });

        currentQuestion = 1; 
    };

    initTest();
})();